// react
import { useDispatch } from 'react-redux';

// components
import { showSnackbar } from '@/redux/snackbarSlice';

/**
 * Returns a `copy` function that writes text to the clipboard and
 * dispatches a snackbar notification on success or failure.
 */
const useCopyToClipboard = () => {
  const dispatch = useDispatch();

  const copy = async (
    text: string | null | undefined,
    successMessage: string,
    errorMessage: string,
  ) => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      dispatch(showSnackbar({ message: successMessage, severity: 'success' }));
    } catch (err) {
      console.error('Failed to copy to clipboard:', err);
      dispatch(showSnackbar({ message: errorMessage, severity: 'error' }));
    }
  };

  return copy;
};

export default useCopyToClipboard;
